module.exports = __webpack_public_path__ + "img/doener-1.68a9c406.jpg";